// extracted by mini-css-extract-plugin
export default {"widget_container":"styles_widget_container__RmCok","admin":"styles_admin__5xHfL","nonAdmin":"styles_nonAdmin__ce70q"};